import {PermissionTypeEnum} from '../enums/permission-type-enum'

export class AuthRejectShip{
    id?: number;
    username?: string;
    initDate?: Date;
    endDate?: Date;
    status?: boolean;
    permissionType?: PermissionTypeEnum;
}